// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"3c493361","429":"52e4f035","453":"02797897","546":"c256d6b9"}[chunkId] + ".chunk.js";
};